export default __webpack_public_path__ + "static/media/referAFriendDesktop@3x.85e86052.png";